// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__eLnSn","messages":"Chat_messages__nE8wi","dateDivider":"Chat_dateDivider__3d_cF"};